exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singleMap[data-v-1294761a]{width:100%;height:100%;display:flex;flex-direction:column}.map-container[data-v-1294761a]{-webkit-tap-highlight-color:rgba(255,255,255,0);position:relative;width:100%;height:100%}.map-container #basemap-selector[data-v-1294761a]{position:absolute;right:8px;top:8px;z-index:1}", ""]);

// exports
